import { API_BASE_URL } from "../../config";
// src/Utils/useFetchUserSeller.js
import { useState, useEffect } from "react";
import { useFetchData } from "./useFetchData";
import { fetchRouteRegistry } from "./fetchRouteRegistry";  // Assuming you have this utility

const useFetchUserSeller = (handleLogout) => {
    const [userIds, setUserIds] = useState([]);
    const { checkToken } = useFetchData(handleLogout);  // Use token helper from existing custom fetch hook

    useEffect(() => {
        const fetchUserSeller = async () => {
            try {
                const token = checkToken();
                if (!token) return;
                const permissions = JSON.parse(localStorage.getItem("user") || "{}").permissions || [];
                const canReadSellers = permissions.includes("superadmin:*")
                    || permissions.includes("auth:admin")
                    || permissions.includes("seller:read")
                    || permissions.includes("seller:*");
                // The list is only a UI filter.  Do not make a dashboard/map
                // unusable when the signed-in role cannot enumerate sellers.
                if (!canReadSellers) {
                    setUserIds([]);
                    return;
                }
                const { response, rows } = await fetchRouteRegistry(token);

                if (!response.ok) {
                    // A 403 is a normal permission denial in V4; only an invalid
                    // token (401) is a reason to end the session.
                    if (response.status === 401) {
                        handleLogout && handleLogout();
                        return;
                    }
                    const text = await response.text();
                    console.error("Failed to fetch route registry:", response.status, text);
                    setUserIds([]);
                    return;
                }

                setUserIds(rows);
            } catch (err) {
                console.error("Error fetching route registry:", err);
                setUserIds([]);
            }
        };

        fetchUserSeller();
    }, [checkToken, handleLogout]);

    return userIds;  // Return the fetched user IDs
};

export default useFetchUserSeller;
